// extracted by mini-css-extract-plugin
export default {"modal":"SchemeModal_modal__en-ZH","modalBody":"SchemeModal_modalBody__fvhIH","holder":"SchemeModal_holder__-fV14","holderImg":"SchemeModal_holderImg__ge41Y"};